import {
  ASSIGN_ROLE,
  CHANGE_USER_STATUS,
  CREATE_ROLE,
  DELETE_ASSIGNED_ROLE,
  DELETE_ROLE,
  GET_CONSTITUENT_ROLES,
  GET_ROLES,
  GET_USERS,
  RECEIVE_USERS,
  receiveConstituentRoles,
  receiveDeleteRoleError,
  receiveNewUsers,
  receiveRoles,
  receiveUsers,
  UPDATE_ROLE,
} from "@/components/permissions/admin/ducks/Actions"
import {
  apiAssignRole,
  apiChangeUserStatus,
  apiCreateRole,
  apiDeleteAssignedRole,
  apiDeleteRole,
  apiGetConstituentRoles,
  apiGetRoles,
  apiGetUsers,
  apiUpdateRole,
} from "@/components/permissions/admin/ducks/AJAX"
import { receiveUpdateUserConstituent } from "@/components/profile/ducks/Actions"

export default (store) => (next) => (action) => {
  const { dispatch } = store
  const receiveRolesSuccess = (cb) => (resp) => {
    dispatch(receiveRoles(resp.roles))
    if (cb) {
      cb()
    }
  }
  const receiveConstituentRolesSuccess = (cb) => (resp) => {
    dispatch(receiveConstituentRoles(resp.constituentRoles))
    if (cb) {
      cb()
    }
  }
  const receiveUpdateRolesSuccess = (cb) => (resp) => {
    dispatch(receiveRoles(resp.roles))
    dispatch(receiveUpdateUserConstituent(resp.currentConstituent))
    if (cb) {
      cb()
    }
  }
  const receiveDeleteRolesSuccess = (cb) => (response) => {
    dispatch(receiveRoles(response.roles))
    dispatch(receiveNewUsers(response))
    if (cb) {
      cb()
    }
  }
  const dispatchReceiveDeleteRolesError = (cb) => () => {
    dispatch(receiveDeleteRoleError())
    if (cb) {
      cb()
    }
  }

  switch (action.type) {
    case CHANGE_USER_STATUS:
      apiChangeUserStatus(action.params, receiveUsers, action.error, action.success)
      return next(action)

    case GET_USERS:
      apiGetUsers(receiveUsers, 0, action.error, action.success)
      return next(action)

    case RECEIVE_USERS:
      if (action.resp.nextUsersPage) {
        apiGetUsers(receiveUsers, action.resp.nextUsersPage, action.error, action.success)
      }
      return next(action)

    case CREATE_ROLE:
      apiCreateRole(action.params, receiveRolesSuccess(action.success), action.error)
      return next(action)

    case ASSIGN_ROLE:
      apiAssignRole(action.params, receiveNewUsers, action.error, action.success)
      return next(action)

    case GET_ROLES:
      apiGetRoles(receiveRolesSuccess(action.success), action.error)
      return next(action)

    case GET_CONSTITUENT_ROLES:
      apiGetConstituentRoles(receiveConstituentRolesSuccess(action.success), action.error)
      return next(action)

    case DELETE_ROLE:
      apiDeleteRole(
        action.roleId,
        receiveDeleteRolesSuccess(action.success),
        dispatchReceiveDeleteRolesError(action.error),
      )
      return next(action)

    case DELETE_ASSIGNED_ROLE:
      apiDeleteAssignedRole(action.assignedRoleId, receiveNewUsers, action.error, action.success)
      return next(action)

    case UPDATE_ROLE:
      apiUpdateRole(
        action.roleId,
        action.params,
        receiveUpdateRolesSuccess(action.success),
        action.error,
      )
      return next(action)

    default:
      return next(action)
  }
}
